import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import './css/mobile.css';
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { change_Current_Location, changeHeaderTitle } from "../store";

export default function UrlUserHistory() {
    const dispatch = useDispatch();
    const { state } = useLocation();

    const fmt = (n) =>
        typeof n === "number"
            ? n.toLocaleString("ko-KR")
            : (Number(n) || 0).toLocaleString("ko-KR");

    // ===== 목업 기본값 =====
    const mock = {
        orderId: "ORD-20250912-0001",
        orderedAt: new Date().toISOString(),
        buyer: {
            name: "강재원(집)",
            tel: "010-7284-7899",
            address1: "경기도 수원시 장안구 장안로 271 (정자동) 115-705",
            postcode: "16336",
        },
        items: [
            {
                merchantName: "보넬드",
                productName: "[100% NFC 토마토 14개 착즙] 보넬드 아이엠 토마토 주스 즙 원액 1L, 3개",
                quantity: 1,
                unitPrice: 23000,
                originalUnit: 23000,
                thumbnail: "https://picsum.photos/id/1080/1200/900",
                optionText: "수량",
            },
        ],
        deliveryFee: 0,
        subtotal: 23000,
        total: 23000,
        payment: {
            method: "신용카드",
            cardMasked: "하나 9416 **** **** ****",
            payType: "일시불",
            email: "wodnjs***@naver.com",
        },
        cashReceipt: { issued: true, type: "소득공제용", info: "010-****-****" },
    };

    // 외부에서 온 값 병합
    const data = { ...mock, ...(state?.receipt || {}) };
    const item = data.items?.[0] || {};

    // 상품 표시용 파생 값
    const merchantName = item.merchantName || "가맹점";
    const productName = item.productName || "상품명";
    const quantity = Number(item.quantity ?? 1);
    const unitPrice = Number(item.unitPrice ?? 0);
    const originalUnit = Number(item.originalUnit ?? unitPrice);
    const hasDiscount = originalUnit > unitPrice;
    const prodImg = item.thumbnail || "";
    const totalAmount =
        typeof data.total === "number"
            ? data.total
            : unitPrice * quantity + (data.deliveryFee || 0);

    // 헤더 타이틀
    useEffect(() => {
        dispatch(change_Current_Location("주문완료내역"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "주문완료내역",
                subTitle: data.orderId || "",
            })
        );
    }, [dispatch, data.orderId]);

    // ===== 인증 게이트 =====
    const [verified, setVerified] = useState(false);
    const [gateName, setGateName] = useState("");
    const [gateOrder, setGateOrder] = useState("");
    const [gateError, setGateError] = useState("");

    const handleOrderChange = (e) => {
        // 영문/숫자만 허용
        const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 40);
        setGateOrder(value);
    };

    const normalizeName = (s) =>
        String(s || "").replace(/\(.*?\)/g, "").replace(/\s+/g, "").trim();
    const normalizeOrder = (s) =>
        String(s || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    const verify = () => {
        const nameOK =
            normalizeName(gateName) === normalizeName(data.buyer?.name) ||
            normalizeName(gateName) ===
            normalizeName(data.buyer?.name).replace(/\(.*?\)/g, "");
        const orderOK = normalizeOrder(gateOrder) === normalizeOrder(data.orderId);

        if (nameOK && orderOK) {
            setVerified(true);
            setGateError("");
        } else {
            setGateError("이름 또는 주문번호가 일치하지 않습니다.");
        }
    };

    const onGateSubmit = (e) => {
        e.preventDefault();
        // verify(); // 실제 검증 사용 시 주석 해제
        setVerified(true); // 데모/개발용
    };

    // 날짜 포맷: 2025.06.06. 20:12:16
    const formatOrderDate = (iso) => {
        const d = new Date(iso);
        if (isNaN(d)) return "";
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        const HH = String(d.getHours()).padStart(2, "0");
        const MM = String(d.getMinutes()).padStart(2, "0");
        const SS = String(d.getSeconds()).padStart(2, "0");
        return `${yyyy}.${mm}.${dd}. ${HH}:${MM}:${SS}`;
    };

    // 게이트 화면
    if (!verified) {
        return (
            <div style={{ background: "#fff" }}>
                <div className="urlUserHistory-gate">
                    <form className="urlUserHistory-gateCard" onSubmit={onGateSubmit}>
                        <h1 className="urlUserHistory-gateTitle">주문내역 확인</h1>

                        <div className="urlUserHistory-gateRow">
                            <label className="urlUserHistory-gateLabel">이름</label>
                            <input
                                className="urlUserHistory-gateInput"
                                placeholder="이름 입력"
                                value={gateName}
                                onChange={(e) => setGateName(e.target.value)}
                                autoComplete="name"
                            />
                        </div>

                        <div className="urlUserHistory-gateRow">
                            <label className="urlUserHistory-gateLabel">주문번호</label>
                            <input
                                className="urlUserHistory-gateInput"
                                placeholder="주문번호 입력 (영문/숫자)"
                                value={gateOrder}
                                onChange={handleOrderChange}
                                autoComplete="off"
                                inputMode="text"
                                spellCheck={false}
                            />
                        </div>

                        {gateError && (
                            <div className="urlUserHistory-gateError">{gateError}</div>
                        )}

                        <button
                            type="submit"
                            className="urlUserHistory-gateBtn"
                            disabled={!gateName.trim() || !gateOrder.trim()}
                        >
                            확인
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    // 인증 통과 후 상세
    return (
        <div
            style={{
                minHeight: "100dvh",
                height: "100%",
                background: "#f3f5f7",
            }}
        >
            <div className="urlUserHistory-wrap">
                {/* 상단: 이미지처럼 날짜/주문번호 만 표시 (영수증 버튼 제거) */}
                <section className="urlUserHistory-section">
                    <div className="urlUserHistory-orderHeader">
                        <div>
                            <div className="urlUserHistory-orderMeta">
                                {formatOrderDate(data.orderedAt)}
                            </div>
                            <div className="urlUserHistory-orderNo">
                                주문번호 {data.orderId}
                            </div>
                        </div>
                    </div>
                </section>

                {/* 배송지 */}
                <section className="urlUserHistory-section">
                    <h2 className="urlUserHistory-title">배송지</h2>
                    <div className="urlUserHistory-card">
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">받는사람</div>
                            <div className="urlUserHistory-value">{data.buyer.name}</div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">연락처</div>
                            <div className="urlUserHistory-value">{data.buyer.tel}</div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">우편번호</div>
                            <div className="urlUserHistory-value">{data.buyer.postcode}</div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">주소</div>
                            <div className="urlUserHistory-value">{data.buyer.address1}</div>
                        </div>
                    </div>
                </section>

                {/* 주문상품 */}
                <section className="urlPayment-section">
                    <h2 className="urlPayment-title">주문상품</h2>

                    <div className="urlPayment-card card1">
                        <div className="urlPayment-orderHead">
                            <div className="urlPayment-store">{merchantName}</div>
                            {/* <div className="urlPayment-shipFee">
                                {Number(data.deliveryFee || 0) > 0
                                    ? `배송비 ${fmt(data.deliveryFee)}원`
                                    : "배송비 무료"}
                            </div> */}
                        </div>

                        <div className="urlPayment-orderBody">
                            <div className="urlPayment-thumb">
                                {prodImg ? (
                                    <img src={prodImg} alt="" className="urlPayment-thumbImg" />
                                ) : null}
                            </div>
                            <div className="urlPayment-info">
                                <div className="urlPayment-prod">{productName}</div>

                                {/* 옵션/수량 + 단가 */}
                                <div className="urlPayment-itemBar">
                                    <div className="urlPayment-itemLeft">
                                        수량&nbsp;:&nbsp;{quantity}개
                                    </div>
                                    <div className="urlPayment-itemRight">
                                        {hasDiscount && (
                                            <span className="urlPayment-priceOld">
                                                {fmt(originalUnit * quantity)}원
                                            </span>
                                        )}
                                        <span className="urlPayment-priceNow">
                                            {fmt(unitPrice * quantity)}원
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 총 주문금액 */}
                        <div className="urlPayment-totalInline">
                            <span className="urlPayment-totalLabel">총 주문금액</span>
                            <b className="urlPayment-totalValue">
                                {fmt(totalAmount)}원
                            </b>
                        </div>
                    </div>
                </section>

                {/* 결제정보 */}
                <section className="urlUserHistory-section">
                    <h2 className="urlUserHistory-title">결제정보</h2>
                    <div className="urlUserHistory-card">
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">결제수단</div>
                            <div className="urlUserHistory-value">{data.payment.method}</div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">카드</div>
                            <div className="urlUserHistory-value">
                                {data.payment.cardMasked} <span> | </span>{" "}
                                {data.payment.payType}
                            </div>
                        </div>
                        <div className="urlUserHistory-row">
                            <div className="urlUserHistory-label">이메일</div>
                            <div className="urlUserHistory-value">{data.payment.email}</div>
                        </div>
                    </div>
                </section>

                {/* 현금영수증 */}
                <section className="urlUserHistory-section">
                    <h2 className="urlUserHistory-title">현금영수증</h2>
                    <div className="urlUserHistory-card">
                        {data.cashReceipt?.issued ? (
                            <>
                                <div className="urlUserHistory-row">
                                    <div className="urlUserHistory-label">발급 구분</div>
                                    <div className="urlUserHistory-value">
                                        {data.cashReceipt.type}
                                    </div>
                                </div>
                                <div className="urlUserHistory-row">
                                    <div className="urlUserHistory-label">발행정보</div>
                                    <div className="urlUserHistory-value">
                                        {data.cashReceipt.info}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="urlUserHistory-row">
                                <div className="urlUserHistory-label">발급 여부</div>
                                <div className="urlUserHistory-value">발급안함</div>
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </div>
    );
}
